import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { Reveal } from "../store/Reveal";

export const ReviewsSection = ({ reviews }) => {
  if (reviews.length === 0) return null;
  return (
    <section data-testid="home-reviews-section" className="max-w-7xl mx-auto px-4 sm:px-8 pb-20 lg:pb-28">
      <Reveal>
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#2E8A57] mb-3">Dicono di noi</p>
        <h2 className="font-serif-display font-bold text-2xl sm:text-3xl lg:text-4xl text-[#1C1917] tracking-tight max-w-xl">
          Le recensioni dei nostri clienti
        </h2>
      </Reveal>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.map((r, i) => (
          <Reveal key={r.id} delay={(i % 3) * 0.08}>
            <div data-testid={`home-review-${r.id}`} className="h-full bg-white border border-[#E7E0D8] rounded-2xl p-7 flex flex-col hover:shadow-[0_20px_50px_-30px_rgba(28,25,23,0.35)] transition-shadow duration-300">
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((s) => (
                  <Star key={s} className={`w-4 h-4 ${s <= r.rating ? "fill-[#7DC242] text-[#7DC242]" : "text-[#E7E0D8]"}`} />
                ))}
              </div>
              <p className="text-sm text-[#44403C] leading-relaxed italic flex-1">"{r.comment}"</p>
              <div className="mt-5 pt-4 border-t border-[#E7E0D8]">
                <p className="font-serif-display font-semibold text-[#1C1917]">{r.name}</p>
                {r.product_name && (
                  <Link to={`/prodotto/${r.slug}`} className="font-mono-accent text-[10px] uppercase tracking-[0.15em] text-[#2E8A57] hover:underline">
                    {r.product_name}
                  </Link>
                )}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
